import { render, staticRenderFns } from "./FilesWrapper.vue?vue&type=template&id=7ebb100c&scoped=true&"
import script from "./FilesWrapper.vue?vue&type=script&lang=js&"
export * from "./FilesWrapper.vue?vue&type=script&lang=js&"
import style0 from "./FilesWrapper.vue?vue&type=style&index=0&id=7ebb100c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ebb100c",
  null
  
)

export default component.exports